import React from 'react';
import css from './OfferForm.module.css';
import {
  composeValidators,
  moneySubUnitAmountAtLeast,
  numberAtLeast,
  required,
} from '../../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldCurrencyInput,
  FieldTextInput,
  Tooltip,
} from '../../../components';
import appSettings from '../../../config/settings';
import { Form as FinalForm } from 'react-final-form';
import { types as sdkTypes } from '../../../util/sdkLoader';
import classNames from 'classnames';
import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from 'react-intl';
import Icons from '../../../components/Icons/Icons';
const { Money } = sdkTypes;

const OfferForm = props => {
  const { listing } = props;
  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          handleSubmit,
          inProgress,
          intl,
          invalid,
          values,
          config,
          sendOfferError,
        } = fieldRenderProps;

        const marketplaceCurrency = config.currency;
        const { formatMessage } = intl;
        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = submitInProgress || invalid;

        const priceRequired = required(intl.formatMessage({ id: 'OfferForm.priceRequired' }));

        const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
        const minPriceRequired = moneySubUnitAmountAtLeast(
          formatMessage({ id: 'OfferForm.priceTooLow' }, { minPrice: formatMoney(intl, minPrice) }),
          config.listingMinimumPriceSubUnits
        );

        const priceValidators = config.listingMinimumPriceSubUnits
          ? composeValidators(priceRequired, minPriceRequired)
          : priceRequired;

        const publicData = listing?.attributes?.publicData || {};
        const unitType = publicData?.unitType;
        const isItemUnitType = unitType === 'item';
        const currentStock = listing?.currentStock?.attributes?.quantity;
        const hasStockLimit = Number.isInteger(currentStock);
        const moqRaw = publicData?.moq;
        const moq = Number.isInteger(moqRaw) ? moqRaw : Number.parseInt(moqRaw, 10);
        const hasMoq = Number.isInteger(moq) && moq > 0;

        const quantityRequired = required(formatMessage({ id: 'OfferForm.quantityRequired' }));
        const quantityInvalid = numberAtLeast(
          formatMessage({ id: 'OfferForm.quantityInvalid' }),
          1
        );

        const maxQuantity = max => value => {
          const parsed = Number(value);
          if (!Number.isInteger(parsed)) return formatMessage({ id: 'OfferForm.quantityInvalid' });
          return parsed <= max
            ? undefined
            : formatMessage({ id: 'OfferForm.quantityAboveStock' }, { stock: max });
        };

        const minQuantity = min => value => {
          const parsed = Number(value);
          if (!Number.isInteger(parsed)) return formatMessage({ id: 'OfferForm.quantityInvalid' });
          return parsed >= min
            ? undefined
            : formatMessage({ id: 'OfferForm.quantityBelowMoq' }, { moq: min });
        };

        const quantityValidators = isItemUnitType
          ? composeValidators(
              quantityRequired,
              quantityInvalid,
              ...(hasMoq ? [minQuantity(moq)] : []),
              ...(hasStockLimit ? [maxQuantity(currentStock)] : [])
            )
          : undefined;

        const quantity = values?.quantity || 1;

        const offerPriceInfo = intl.formatMessage({ id: 'OfferForm.offerPriceInfo' }, { quantity });

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            {isItemUnitType ? (
              <>
                <FieldTextInput
                  id="quantity"
                  name="quantity"
                  className={css.input}
                  type="number"
                  min={hasMoq ? moq : 1}
                  step="1"
                  label={formatMessage({ id: 'OfferForm.quantityLabel' })}
                  placeholder={formatMessage({ id: 'OfferForm.quantityPlaceholder' })}
                  validate={quantityValidators}
                  autoFocus={true}
                />
                {/* {hasMoq ? (
                  <p className={css.hint}>
                    {formatMessage({ id: 'OfferForm.minimumOrderHint' }, { moq })}
                  </p>
                ) : null}
                {hasStockLimit ? (
                  <p className={css.hint}>
                    {formatMessage({ id: 'OfferForm.availableStockHint' }, { stock: currentStock })}
                  </p>
                ) : null} */}
              </>
            ) : null}

            <div className={css.formFld}>
              <div className={css.labelWithTooltip}>
                <label htmlFor={`offerPrice`}>
                  {intl.formatMessage({ id: 'OfferForm.priceLabel' })}
                </label>

                <Tooltip content={offerPriceInfo} position="top">
                  <span className={css.infoIcon}>
                    <Icons name="info" />
                  </span>
                </Tooltip>
              </div>
              <FieldCurrencyInput
                id="price"
                name="price"
                className={css.input}
                // label={formatMessage({ id: 'OfferForm.priceLabel' })}
                placeholder={intl.formatMessage({
                  id: 'OfferForm.priceInputPlaceholder',
                })}
                currencyConfig={appSettings.getCurrencyFormatting(marketplaceCurrency)}
                validate={priceValidators}
                autoFocus={!isItemUnitType}
                prefixSymbol={true}
              />
              <p className={css.hint}>{offerPriceInfo}</p>
            </div>

            <div className={css.actionBtns}>
              {sendOfferError ? (
                <p className={css.error}>{formatMessage({ id: 'OfferForm.sendEnquiryError' })}</p>
              ) : null}
              <PrimaryButton
                className={css.submitBtn}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
              >
                {formatMessage({ id: 'OfferForm.submitButtonText' })}
              </PrimaryButton>
            </div>
          </Form>
        );
      }}
    />
  );
};

export default OfferForm;
